<template>
  <div>
    <HeaderStudent />
    <router-view />
  </div>
</template>

<script>
import HeaderStudent from '@/components/Layouts/HeaderStudent';

export default {
  components: {
    HeaderStudent
  }
};
</script>
